import { Box } from '@mui/material';
import { InfinitySpin } from 'react-loader-spinner';
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import { useTimeSheet } from './Config/TimeSheetContext';
import BadgeBoard from './Pages/BadgeBoard/BadgeBoard';
import CreateDailySheet from './Pages/CreateDailySheet/CreateDailySheet';
import LeadCreation from './Pages/LeadCreation/LeadCreation';
import LeaderBoard from "./Pages/LeaderBoard/LeaderBoard";
const App = () => {
  const { timeSheetUserDetails, isLoading } = useTimeSheet();
  if (isLoading) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: '100vh',
        background: 'rgba(13, 18, 41, 1)',
      }}>
        <InfinitySpin
          visible={true}
          width="200"
          color="#4fa94d"
          ariaLabel="infinity-spin-loading"
        />
      </Box>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/lead-creation" />} />
      <Route path="/lead-creation" element={<LeadCreation />} />
      {timeSheetUserDetails && (
        <>
          <Route path="/leader-board" element={<LeaderBoard />} />
          <Route path="/create-daily-sheet" element={<CreateDailySheet />} />
          <Route path="/badge" element={<BadgeBoard />} />
        </>
      )}
    </Routes>
  );
};

export default App;
